import { Button, Space } from 'antd';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import DatePicker from './DatePicker';
import { LogicalFilter } from '@refinedev/core';

type Props = {
  currentFilters: LogicalFilter[];
  setFilters: (filters: LogicalFilter[], mode?: 'replace' | 'merge') => void;
  allowClear?: boolean;
  field?: string;
};

export const DateFilter = ({
  currentFilters,
  setFilters,
  allowClear = true,
  field = 'date',
}: Props) => {
  const getDateFilter = () => {
    const date = currentFilters.find((filter) => filter.field === field)?.value;
    return date ? new Date(date) : null;
  };

  const setDateFilter = (date: Date) => {
    setFilters([
      {
        field,
        operator: 'eq',
        value: date
          .toLocaleDateString('ja-JP', { year: 'numeric', month: '2-digit', day: '2-digit' })
          .split('/')
          .join('-'),
      },
    ]);
  };

  const clearDateFilter = () => {
    setFilters(
      currentFilters.filter((filter) => filter.field !== field),
      'replace',
    );
  };

  const back = () => {
    const date = getDateFilter();
    if (date) {
      date.setDate(date.getDate() - 1);
      setDateFilter(date);
    }
  };

  const forward = () => {
    const date = getDateFilter();
    if (date) {
      date.setDate(date.getDate() + 1);
      setDateFilter(date);
    }
  };

  const onSelectedDate = (date: Date | null) => {
    if (date) {
      setDateFilter(date);
    } else {
      if (allowClear) {
        clearDateFilter();
      }
    }
  };

  return (
    <Space>
      <Button icon={<ArrowLeftOutlined />} onClick={back} />
      <DatePicker
        picker="date"
        value={getDateFilter()}
        onChange={onSelectedDate}
        allowClear={allowClear}
      />
      <Button icon={<ArrowRightOutlined />} onClick={forward} />
    </Space>
  );
};
